module.exports = __webpack_public_path__ + "img/connection-2.57122f9b.svg";